"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var FallbackCell = function FallbackCell(accessor, fallback) {
  return function (props) {
    var field = props[accessor];

    if (!field) {
      return fallback;
    }

    return field;
  };
};

var _default = FallbackCell;
exports.default = _default;